module.exports = __webpack_public_path__ + "img/9e33854.jpg";